module.exports = __webpack_public_path__ + "static/media/income.ae80b008.png";